module.exports = __webpack_public_path__ + "static/media/envelope.1a9020c3.svg";